module.exports = __webpack_public_path__ + "img/product-advantage1.8403bc0f.svg";